module.exports = __webpack_public_path__ + "img/upload-file.9232d3d6.svg";